import React from 'react';
import { CreditCard } from 'lucide-react';

const InsertCard = ({ onCardClick, onEnterAmount, config }) => (
  <div className={`bg-white text-gray-800 h-full flex flex-col items-center justify-center p-3 ${config.ui.maxWidth} mx-auto`}>
    <div className="text-center space-y-4 max-w-xs">
      <CreditCard className="w-16 h-16 mx-auto text-blue-600 animate-pulse" />
      <div className="text-xl font-bold text-gray-800">PAYMENT TERMINAL</div>
      <div className="text-sm text-gray-600 font-medium">Touch to begin transaction</div>
    </div>
    <div className="flex flex-col space-y-3 mt-8">
      <button 
        onClick={onEnterAmount}
        className="px-8 py-4 bg-blue-600 text-white font-bold text-lg rounded-xl hover:bg-blue-700 transition-colors"
      >
        START TRANSACTION
      </button>
    </div>
  </div>
);

export default InsertCard;